import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';
import { TasksListGetQueryParamsInterface } from './definitions/tasks-list-get-query-params.interface';
import { PagedResponseInterface } from 'src/app/shared/classes/paged-response.interface';
import { createQueryParams } from './task-list-get-query-params-factory';
import { TasksListResponseItemResponse } from './definitions/tasks-list-response.interface';
import { ConfigService } from '../../config/config.service';

@Injectable()
export class GetTasksListService {

    private apiUrl: string = this.configService.config.rest.apiV2Url;

    constructor(private client: HttpClient, private configService: ConfigService) {}

    public getTasksList(paramsObj: TasksListGetQueryParamsInterface): Observable<PagedResponseInterface<TasksListResponseItemResponse>> {
      const url = `${this.apiUrl}/tasks`;

      const params: HttpParams = createQueryParams(paramsObj);

      return this.client.get<PagedResponseInterface<TasksListResponseItemResponse>>(url, { params }).pipe(
        catchError(error => throwError(handleProblem(error)))
      );
    }
}
